import React, { useState, ChangeEvent } from 'react';
import { cn } from '@/lib/utils';
import { FormField, FormItem, FormLabel, FormMessage } from '@/components/ui/form';
import FileIconTwo from '@/components/icons/FileIconTwo';

interface FileUploadCardProps {
    name: string;
    error?: string;
    className?: string;
    label?: string;
    onUploadClick?: () => void;
}

export default function FileUploadCard({ name, error, className, label, onUploadClick }: FileUploadCardProps) {
    const [fileName, setFileName] = useState<string | null>(null);

    const handleFileChange = (event: ChangeEvent<HTMLInputElement>, field: any) => {
        const file = event.target.files?.[0];
        if (file) {
            setFileName(file.name);
            field.onChange(file);
            if (onUploadClick) onUploadClick();
        }
    };

    return (
        <FormField
            name={name}
            render={({ field }) => (
                <FormItem className={cn('space-y-2 w-full', className)}>
                    <FormLabel className="block mb-1 text-[16px] font-medium text-primery-blue-900">
                        {label}
                    </FormLabel>
                    <div className="flex justify-between bg-gray-50 bg-transparent border border-gray-300 rounded-md w-full pe-2">
                        <label className="flex gap-2 cursor-pointer flex-1">
                            <span className="text-[#B6B5BF] text-sm bg-[#E6E6E6] bg-transparent h-full px-3 flex items-center">
                                Upload
                            </span>
                            <span className="block w-[1px] h-full bg-[#B6B5BF]"></span>
                             
                    
                            <div className="flex items-center gap-1 flex-1 justify-start">
                                <span className="text-[#B6B5BF] text-sm">
                                    {fileName || 'File.pdf'}
                                </span>
                                <div className="flex items-center gap-2">
                                    <FileIconTwo className="!w-6 !h-6 text-[#B6B5BF]" />
                                </div>
                            </div>
                            <input
                                type="file"
                                className="hidden"
                                onChange={(e) => handleFileChange(e, field)}
                                accept="image/*, .pdf"
                            />
                        </label>
                        <div className="p-1 rounded-full border border-[#B6B5BF] w-fit my-[6px]">
                            <CheckIcon className="w-5 h-5 text-[#B6B5BF]" />
                        </div>
                    </div>
                    <FormMessage>{error}</FormMessage>
                </FormItem>
            )}
        />
    );
}

const CheckIcon = ({ className }: { className: string }) => (
    <svg
        className={className}
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path d="M5 13L9 17L19 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);
